import Button from '#/components/Button/Button';
import React, { useRef } from 'react';
import styles from './UploadAttachments.module.scss';

interface UploadAttachmentsProps {
  value: File[];
  onChange: (files: File[]) => void;
}

export const UploadAttachments: React.FC<UploadAttachmentsProps> = ({ value, onChange }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);
    onChange([...value, ...files]);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  const handleRemoveFile = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  return (
    <div>
      <Button secondary onPress={() => inputRef.current?.click()}>
        Add Attachments
      </Button>
      <input
        ref={inputRef}
        type="file"
        multiple
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />
      {value.length > 0 && (
        <ul className={styles.list}>
          {value.map((file, index) => (
            <li key={`${file.name}-${index}`}>
              <span>{file.name}</span>
              <Button secondary onPress={() => handleRemoveFile(index)}>
                Remove
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
